import { customerConstants } from '../constants'

const inits = { loading: true, items: [] }
const init = { loading: true, item: { all: '0', pending: '0', success: '0', reject: '0' } }

export function customers_book(state = inits, action) {
	switch (action.type) {
		case customerConstants.GET_CUSTOMER_BY_AUTH_AND_STATUS_REQUEST:
			return {
				...state,
				loading: true,
			}
		case customerConstants.GET_CUSTOMER_BY_AUTH_AND_STATUS_SUCCESS:
			return {
				...state,
				items: action.customers_book,
				loading: false,
			}
		case customerConstants.GET_CUSTOMER_BY_AUTH_AND_STATUS_FAILURE:
			return {
				...state,
				error: action.error,
				loading: false,
			}

		// SAVE
		case customerConstants.NEW_BOOK_CUSTOMER_REQUEST:
			return {
				...state,
				loading: true,
			}
		case customerConstants.NEW_BOOK_CUSTOMER_SUCCESS:
			return {
				...state,
				items: state.items.concat(action.response),
				loading: false,
			}
		case customerConstants.NEW_BOOK_CUSTOMER_FAILURE:
			return {
				...state,
				error: action.error,
				loading: false,
			}

		// DELETE
		case customerConstants.DELETE_BOOK_CUSTOMER_REQUEST:
			return {
				...state,
				loading: true,
			}
		case customerConstants.DELETE_BOOK_CUSTOMER_SUCCESS:
			return {
				...state,
				loading: false,
				items: state.items.filter(book => book.id !== action.id),
			}
		case customerConstants.DELETE_BOOK_CUSTOMER_FAILURE:
			return {
				...state,
				error: action.error,
				loading: false,
			}

		default:
			return state
	}
}

export function customer_info(state = init, action) {
	switch (action.type) {
		case customerConstants.GET_CUSTOMER_INFO_BY_AUTH_REQUEST:
			return {
				...state,
				loading: true,
			}
		case customerConstants.GET_CUSTOMER_INFO_BY_AUTH_SUCCESS:
			return {
				...state,
				item: action.customer_info,
				loading: false,
			}
		case customerConstants.GET_CUSTOMER_INFO_BY_AUTH_FAILURE:
			return {
				...state,
				error: action.error,
				loading: false,
			}

		default:
			return state
	}
}
